import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CoinTypeState } from './coin-type.reducer';

export const selectCoinTypeState = createFeatureSelector<CoinTypeState>('coinType');

export const selectAllCoinTypes = createSelector(
  selectCoinTypeState,
  (state) => state.coinTypes
);

export const selectCoinTypeLoading = createSelector(
  selectCoinTypeState,
  (state) => state.loading
);

export const selectCoinTypeError = createSelector(
  selectCoinTypeState,
  (state) => state.error
);
